import { Body, Col, Divider, Frow, Heading2, Lead } from '@pinpointhq/thumbtack';
import * as React from 'react';

interface IFormRow extends React.HTMLAttributes<HTMLDivElement> {
  ariaLabel?: string;
  children: React.ReactNode;
  header?: string;
  leadingHeader?: boolean;
  largeDescription?: boolean;
  showDivider?: boolean;
  text?: React.ReactNode;
}

export function FormRow({
  ariaLabel = '',
  children,
  header,
  largeDescription = false,
  leadingHeader = false,
  text,
  showDivider = true,
  ...props
}: IFormRow) {
  const hasHeader = !!header;
  const headerCopy = leadingHeader ? <Lead className="mar-b-2">{header}</Lead> : <Heading2>{header}</Heading2>;
  return (
    <div aria-label={ariaLabel} {...props}>
      {showDivider && <Divider muted={true} className="mar-v-4" />}
      <Frow flexDirection="column" verticalGutters={24} sm={{ flexDirection: 'row', gutters: 24 }}>
        <Col sm={{ width: '1-3' }} md={{ width: largeDescription ? '1-2' : '2-5' }}>
          {hasHeader && headerCopy}
          {text && typeof text === 'string' ? <Body muted={true}>{text}</Body> : text}
        </Col>
        <Col sm={{ width: '2-3' }} md={{ width: largeDescription ? '1-2' : '3-5' }}>
          {children}
        </Col>
      </Frow>
    </div>
  );
}

export default FormRow;
